import { IPaginationParams } from 'APIPackage/MainModule/interfaces/IPaginationParams';
import { createPaginationParams } from 'APIPackage/MainModule/common/createPaginationParams';
import { IExport } from 'APIPackage/ImportExportModule/interfaces/IExport';
import { LawInterfacesEnum } from 'CorePackage/MainModule/enums/LawInterfacesEnum';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { getLawInterfaceFromStorage } from 'CorePackage/MainModule/common/getLawInterfaceFromStorage';
import { ExportFormatsEnum } from 'APIPackage/ImportExportModule/enums/ExportFormatsEnum';
import { apiDelete, apiGet, apiPost } from 'APIPackage/MainModule/common/apiTools';

import { IChecklistTemplateUpdate } from '../interfaces/IChecklistTemplateUpdate';
import { IChecklistTemplate } from '../interfaces/IChecklistTemplate';
import { IPageChecklistTemplate } from '../interfaces/IPageChecklistTemplate';

export interface IFetchChecklistTemplatesParams extends IPaginationParams {
  needQuestions?: boolean;
}

export async function fetchChecklistTemplates({
  needQuestions,
  ...paginationParams
}: IFetchChecklistTemplatesParams): Promise<IPageChecklistTemplate> {
  const queryParams = createPaginationParams(paginationParams);

  if (needQuestions) {
    queryParams.append('needQuestions', needQuestions.toString());
  }

  return apiGet<IPageChecklistTemplate>(
    `${getServiceBaseURL(APIServiceEnum.DEFAULT_SERVICE)}/checklist-templates${
      queryParams.toString().length ? `?${queryParams}` : ''
    }`,
  );
}

export async function fetchChecklistTemplate(id: number): Promise<IChecklistTemplate> {
  return apiGet(`${getServiceBaseURL(APIServiceEnum.DEFAULT_SERVICE)}/checklist-templates/${id}`);
}

interface IFetchChecklistTemplatesUpdate {
  data: IChecklistTemplateUpdate;
}

export async function fetchChecklistTemplateUpdate({
  data,
}: IFetchChecklistTemplatesUpdate): Promise<IChecklistTemplate> {
  return apiPost<IChecklistTemplate>({
    url: `${getServiceBaseURL(APIServiceEnum.DEFAULT_SERVICE)}/checklist-templates`,
    body: data,
  });
}

export async function fetchChecklistTemplateSetDefault(id: number): Promise<IChecklistTemplate> {
  return apiPost<IChecklistTemplate>({
    url: `${getServiceBaseURL(APIServiceEnum.DEFAULT_SERVICE)}/checklist-templates/${id}/default`,
  });
}

export async function fetchChecklistTemplateDelete(id: number): Promise<IChecklistTemplate> {
  return apiDelete<IChecklistTemplate>(
    `${getServiceBaseURL(APIServiceEnum.DEFAULT_SERVICE)}/checklist-templates/${id}`,
  );
}

interface IFetchChecklistExport {
  id: number;
  format: ExportFormatsEnum;
}

export async function fetchChecklistExport({ id, format }: IFetchChecklistExport): Promise<IExport> {
  const lawInterface = getLawInterfaceFromStorage();
  const params = new URLSearchParams();

  params.set('format', format);
  params.set('isFederalLaw248', String(lawInterface === LawInterfacesEnum.FZ_248));

  return apiPost<IExport>({
    url: `${getServiceBaseURL(APIServiceEnum.DEFAULT_SERVICE)}/checklist-templates/export/${id}?${params}`,
  });
}
